import qs from 'query-string';

// eslint-disable-next-line import/prefer-default-export
export function withSearch(url, search) {
  // This line checks for additional filters when the url already
  // has existing ones. For example: zmsAmMerchants async loading
  if (url.indexOf('?') !== -1) return `${url}&${qs.stringify(search)}`;
  return search ? `${url}?${qs.stringify(search)}` : url;
}
